/**
 * Landing-page feature flags.
 * Flip to `true` when the product is ready to launch and re-enable everywhere.
 * Referenced by: App.js, FeaturedProducts, Navigation, Hero.
 */
export const FEATURES = {
  showRevive: true,
};
